module.exports = __webpack_public_path__ + "img/pick3.95155034.png";